import React from 'react';
import { Link } from "react-router-dom";

import classes from './Footer.module.scss';

const Footer = () => {

  return (
    <div className={classes.footer}>
        <p>© {new Date().getFullYear()} DriveTLC.com</p>
        <Link to="/terms">Terms and Conditions</Link>
        <Link to="/privacy">Privacy Policy</Link>
    </div>
  )
}

export default Footer